import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";

const PDFViewer = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const { pdfUrl,MemberID } = location.state || {};
    const [convertedPdfUrl, setConvertedPdfUrl] = useState(null);
    const token = localStorage.getItem("AccessToken") || "YOUR_ACCESS_TOKEN_HERE";
    const contract = useSelector((state) => state.userData);
    useEffect(() => {
        if (!pdfUrl) {
            return;
        }

        const convertPdf = async () => {
            try {
                const payload = {
                    _Params: JSON.stringify({
                        MemberID: MemberID, // Replace with dynamic value if necessary
                        PDF_Document: pdfUrl,
                        DeviceType:"PatientPortal",
                        EmailID:contract.userData.EmailID
                    }),
                };

                const response = await axios.post(
                    Endpoints.LoadandConvertDocument,
                    payload,
                    {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                const result = response.data;
                if (result?.Result === 1 && result?.Data) {
                    setConvertedPdfUrl(result.Data);
                } 
            } catch (error) {
                console.error("Error converting document:", error);
            }
        };

        convertPdf();
    }, [pdfUrl, token]);

    if (!convertedPdfUrl) {
        return <p><div className="loading-container">
        <div class="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div></p>;
    }

    return (
        <>
            <div className="col-12 mt-4 inner-page-heading-wrapper">
            <button className="win-back-btn" onClick={() => navigate(-1)}><span>
                        <i className="bi bi-chevron-left"></i> {t('back')}
                    </span></button>
                {/* <h1 className="page-heading">Benefits Patient ID</h1> */}
                <h1 className="page-headingg">&nbsp;</h1>
            </div>
            
            <iframe
                src={convertedPdfUrl}
                title="PDF Viewer"
                className="pdf-viewer-iframe"
            />
        </>
    );
};

export default PDFViewer;
